export default {
  respondentInfoMulti: 'customquestionmulti',
  respondentInfoRadio: 'customquestionradio',
  respondentInfoDropdown: 'customquestiondropdown',
  respondentInfoLongText: 'customtextmultiline',
  respondentInfoShortText: 'customquestiontext',
};
